import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { GuestArrivalService } from '../../guest-arrival.service';

@Component({
    selector: 'app-sms',
    templateUrl: './sms.component.html',
    styleUrls: ['./sms.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class SmsComponent implements OnInit {
    reservation: any;
    countries: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private guestArrivalService: GuestArrivalService,
		private constantService: ConstantService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.reservation = data.reservation;
			this.countries = this.constantService.countries;
			
	}

	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	smsId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'messageId': [],
		'toMobileCtry': [],
		'toMobile': [{ type: 'required', message: 'Required' }],
		'smsMessage': [{ type: 'required', message: 'Required' }],
		'sendBySms': [{ type: 'required', message: 'Required' }]
	};
	
	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.form1.patchValue({
			toMobile: this.reservation?.mobilePhone
		});
	}


	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.guestArrivalService.sendSMS(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Successfully send SMS', detail: res.message });
						this.doAdd.emit(res.data.message);
					},
					(err: any) => {
						console.log('sms-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			messageId: [],
			toMobileCtry: ['+1'],
			toMobile: ['', Validators.required],
			smsMessage: ['', Validators.required],
			sendBySms: [true]
		});
	}

}
